import * as tslib_1 from "tslib";
import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
var styles = require('./AdvancedSecurityOptionFull.scss');
var AdvancedSecurityOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(AdvancedSecurityOptionFull, _super);
    function AdvancedSecurityOptionFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdvancedSecurityOptionFull.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.subscription_text_container },
                React.createElement("div", null, strings.options_premium_AdvancedSecurityContent_part1),
                React.createElement("div", null,
                    React.createElement("a", { href: "https://aka.ms/outlookcomadvancedsecurityfaq", target: "_blank" }, strings.options_premium_AdvancedSecurityContent_LearnMore)),
                React.createElement("br", null),
                React.createElement("div", null, strings.options_premium_AdvancedSecurityContent_part2)),
            React.createElement("div", { className: styles.subscription_btn_container },
                React.createElement(PrimaryButton, { text: strings.options_premium_buttonText, "data-is-focusable": true, disabled: false, onClick: this.navigateToAdvancedSecurity, className: styles.addNewItemButton }))));
    };
    AdvancedSecurityOptionFull.prototype.navigateToAdvancedSecurity = function (ev) {
        ev.stopPropagation();
        var advancedSecurityUrl = 'https://aka.ms/outlooktfa ';
        logUsage(datapoints.PremiumDashManageSecurity.datapoint.name);
        window.open(advancedSecurityUrl, '_blank');
    };
    return AdvancedSecurityOptionFull;
}(React.Component));
export default AdvancedSecurityOptionFull;
//# sourceMappingURL=AdvancedSecurityOptionFull.js.map